// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DateTimeUtils } from '../Utils/Time/DateTimeUtils';
export class PortfolioGrowth {
    constructor(date, absoluteAmount) {
        this.Date = date; // Значение “день”
        this.AbsoluteAmount = absoluteAmount; // Значение “абсолютное”
    }
}
export class PortfolioCacheMonthReturn {
    constructor(date, percent, absoluteAmount) {
        this.Date = date; // Значение “день”
        this.Percent = percent; // Значение “процентов”
        this.AbsoluteAmount = absoluteAmount; // Значение “абсолютное”
    }
    get Date() {
        return this.dateFormatted;
    }
    set Date(value) {
        this.date = value;
        if (value) {
            this.dateFormatted = DateTimeUtils.formatDate(value, 'MM.YYYY');
            this.dateInMonthWordFormat = DateTimeUtils.formatDate(value, 'MMM, YYYY');
        }
    }
    get Percent() {
        return this.percentFormatted;
    }
    set Percent(value) {
        this.percent = value;
        this.percentFormatted = value + '%';
    }
    get AbsoluteAmount() {
        return this.absoluteAmountFormatted;
    }
    set AbsoluteAmount(value) {
        var _a;
        this.absoluteAmount = value;
        const acc = (_a = this.DCache) === null || _a === void 0 ? void 0 : _a.getPrimaryAccount();
        this.absoluteAmountFormatted = acc === null || acc === void 0 ? void 0 : acc.formatPrice(value); // .split(' ')[0] + ' USD';
    }
}
export class PortfolioCacheInstrumentReturn {
    constructor(instrument, date, percent) {
        this.ins = instrument; // ссылка на инструмент
        if (instrument) {
            this.instrumentTradableID = instrument.InstrumentTradableID; // Идентификатор инструмента
            this.insName = instrument.DisplayName(); // отображаемое имя
            this.routeId = instrument.Route; // routeID
            this.interiorID = instrument.GetInteriorID(); // for color identification
        }
        this.Date = date; // Значение “день”
        this.Percent = percent; // Значение “процентов”
    }
    get Date() {
        return this.dateFormatted;
    }
    set Date(value) {
        this.date = value;
        if (value) {
            this.dateFormatted = DateTimeUtils.formatDate(value, 'MMM, YYYY');
        }
    }
    get Percent() {
        return this.percentFormatted;
    }
    set Percent(value) {
        this.percent = value;
        this.percentFormatted = value + '%';
    }
    get Instrument() {
        return this.insName;
    }
    get Color() {
        return this.DCache.PortfolioCache.GetColorByInteriorID(this.interiorID);
    }
}
export class PortfolioCacheDailyInstrumentReturn {
    constructor(instrument, date, percent) {
        this.Instrument = instrument; // ссылка на инструмент
        this.Date = date; // Значение “день”
        this.Percent = percent; // Значение “процентов”
    }
}
export class PortfolioCacheDailyCashReturn {
    constructor(date, percent) {
        this.Date = date; // Значение “день”
        this.Percent = percent; // Значение “процентов”
    }
}
export class PortfolioSystem {
    constructor(id, name, managerLogin) {
        this.ID = id;
        this.Name = name;
        this.ManagerLogin = managerLogin;
    }
}
export class PortfolioInvestor {
    constructor(portfolioSystemID, modelID, accountID) {
        this.PortfolioSystemID = portfolioSystemID;
        this.ModelID = modelID;
        this.AccountID = accountID;
    }
}
